export enum AuctionSaleType {
    WantedtoBuy = 0,
    ForSale = 1,
    GeneralSale = 2,
    ClearingSale = 3,
    Genetics = 4,
}
